import { createAction } from '@reduxjs/toolkit';
import { IGetOptimizelyFlagsAction, IGetOptimizelyFlagVariationAction } from 'app/models/Optimizely/Optimizely';

const getOptimizelyFlags = createAction<IGetOptimizelyFlagsAction>('GET_OPTIMIZELY_FLAGS');
const getOptimizelyFlagVariation = createAction<IGetOptimizelyFlagVariationAction>('GET_OPTIMIZELY_FLAG_VARIATION');

export const serviceActions = {
  getOptimizelyFlags,
  getOptimizelyFlagVariation,
};
